import React from 'react';
import { Box, Paper, Skeleton, Typography } from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { formatReportMoney } from './reportEC.utils';

const ReportECSummary = ({
  metadata,
  loading,
}: {
  metadata: any;
  loading: boolean;
}) => (
  <Box
    display="grid"
    gridTemplateColumns={{ xs: '1fr', sm: '1fr 1fr', lg: 'repeat(4, 1fr)' }}
    gap={1.25}
  >
    {[
      {
        label: 'Quantidade',
        value: Number(metadata?.count || 0).toLocaleString('pt-BR'),
        icon: <SwapHorizIcon fontSize="small" />,
        color: 'primary',
      },
      {
        label: 'Valor Total',
        value: formatReportMoney(metadata?.valor_total),
        icon: <AttachMoneyIcon fontSize="small" />,
        color: 'primary',
      },
      {
        label: 'Valor Líquido',
        value: formatReportMoney(metadata?.valor_liberado),
        icon: <AccountBalanceWalletIcon fontSize="small" />,
        color: 'success',
      },
      {
        label: 'Total de taxas',
        value: formatReportMoney(metadata?.valor_taxas),
        icon: <ReceiptLongIcon fontSize="small" />,
        color: 'warning',
      },
    ].map(({ label, value, icon, color }) => (
      <Paper
        key={label}
        aria-busy={loading}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          minWidth: 0,
          p: 1.5,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1.5,
          boxShadow: '0 8px 24px rgba(17, 24, 39, 0.05)',
        }}
      >
        <Box
          sx={{
            display: 'grid',
            placeItems: 'center',
            width: 40,
            height: 40,
            borderRadius: '50%',
            flexShrink: 0,
            bgcolor: `${color}.light3`,
            color: `${color}.main`,
          }}
        >
          {icon}
        </Box>
        <Box minWidth={0}>
          <Typography variant="caption" color="text.secondary" fontWeight={700}>
            {label}
          </Typography>
          {loading ? (
            <Skeleton width={120} height={28} />
          ) : (
            <Typography
              sx={{
                fontSize: 22,
                fontWeight: 800,
                lineHeight: 1.25,
                overflowWrap: 'anywhere',
              }}
            >
              {metadata ? value : '—'}
            </Typography>
          )}
          <Typography variant="caption" color="text.secondary">
            Nos filtros aplicados
          </Typography>
        </Box>
      </Paper>
    ))}
  </Box>
);

export default ReportECSummary;
